import { render } from "./SubunitDropdown.vue?vue&type=template&id=93872f3e"
import script from "./SubunitDropdown.vue?vue&type=script&lang=js"
export * from "./SubunitDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__